import { Injectable } from '@angular/core';
import { USER_MGMT_CNST } from '../constants/proj.cnst';
import { Config, Path } from '../enums';
import { InitService } from '../parsers/init.service';
import { UtilsService } from './utils.service';
import { HttpService } from './http.service';
import { EnvService } from './env.service';
import { UM_TABLE_CNST } from '../constants/table.cnst';
import { isNullOrUndefined } from '../shared/common-utils';
// added for Export-DWG 
import { MessageService } from 'primeng/api';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';


@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private initSrv: InitService,
    private utilsSrv: UtilsService,
    private httpSrv : HttpService,
    private envService : EnvService,
    private readonly messageService: MessageService
  ) { }

  setTableConfig(moduleName: string) {
    let tableConfig: any = {}
    tableConfig['columns'] = UM_TABLE_CNST.TABLE_COLUMNS[moduleName as keyof typeof UM_TABLE_CNST.TABLE_COLUMNS];
    return tableConfig['columns'];
  }

  initializeUserConfig(config: any) {
    return this.initSrv.loadConfig(
      config
    );
  }

  handleOptionClick(e: any, moduleName: string) {
    let modalData: any = []

    if (e.val == USER_MGMT_CNST.OPTIONS.VIEW) {
      if (moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.USER_LIST || moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.USER_CUSTOMER_LIST) {

        const config = {
          path: Path.VIEW_USER_CONFIG_PATH,
          configType: Config.VIEW_USER_CONFIG
        }

        let userId = e['data']['userId'];

        this.getUserInfoByUserId(userId)
          .then((apiResponse: any) => {

            if (!isNullOrUndefined(apiResponse) && Object.keys(apiResponse).length > 0) {
              let { response } = apiResponse;
              let { meta } = response;

              this.initializeUserConfig(config)
                .then(data => {
                  modalData = this.userModalDataValues(e.data, modalData);
                  modalData = this.populateViewUsersModalData(meta, modalData);

                })
                .catch(err => {
                  console.log(err, 'Failed to initialize user config');
                })
            }

          }).catch(err => {
            console.log("Failed to fetch user info");
          })
      } 
    }
    if (e.val == USER_MGMT_CNST.OPTIONS.EDIT) {
      if (moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.USER_LIST || moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.USER_CUSTOMER_LIST) {
        const config = {
          path: Path.EDIT_USER_CONFIG_PATH,
          configType: Config.EDIT_USER_CONFIG
        }

        this.initializeUserConfig(config)
          .then(data => {
            modalData = this.userModalDataValues(e.data, modalData);
            modalData.editAction = true;
          })
          .catch(err => {
            console.log(err, 'waringin here');
          })
      }
      if (moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.PROFILE_LIST || moduleName == USER_MGMT_CNST.LIST_NAME_MAPPING.PROFILE_CUSTOMER_LIST) {
        modalData.editAction = true;
      }
    }
  }

  userModalDataValues(rowData: any, modalData: any) {
    return rowData;
  }

  roleModalDataValues(rowData: any, modalData: any) {
    ;
    modalData.rolename = rowData[0]['values'][0]
    modalData.roledesc = rowData[1]['values'][0]
    modalData.status = rowData[2]['values'][0]
  }

  profileModalDataValues(rowData: any, modalData: any) {
    ;
    modalData.profilename = rowData[0]['values'][0]
    modalData.profiledesc = rowData[1]['values'][0]
    modalData.status = rowData[2]['values'][0]
  }

  adminModalDataValues(rowData: any, modalData: any) {
    ;
    modalData.administratorName = rowData[0]['values'][0]
    modalData.administratorDesc = rowData[1]['values'][0]
    modalData.status = rowData[2]['values'][0]
  }

  loadConfig(config: any){
    let configs = this.initSrv.getConfig(config.configType)
    if(!isNullOrUndefined(configs)){
      return configs;
    }
    return this.initSrv.loadConfig(config);
  }

  getProfilesList(options : any) : Promise<any> {
    let promise = new Promise((resolve) => {
      this.httpSrv
        .makeGetApiCall("LIST_OF_PROFILES", this.envService.baseUrl, options)
        .subscribe({next:(response: any[]) => {
          resolve(response);
        }, 
        error:err => {
          console.log("Error in fetching roles list ", err);
          this.utilsSrv.showToastMessage("Error in fetching roles list ", "error");
          resolve({});
        }
        })
    })

    return promise;
  }

  getUserInfoByUserId(userId : string) : Promise<any> {

    let promise = new Promise((resolve) => {

      if (!isNullOrUndefined(userId)) {

        let options = {
          'uriParams': {
            userId
          }
        }

        this.httpSrv
          .makeGetApiCall('FETCH_USER_INFO_BY_ID', this.envService.baseUrl, options)
          .subscribe({next:(response: any) => {
            resolve(response);
          },
          error:error => {
            console.log("Error in fetching user info by user id ", error);
            this.utilsSrv.showToastMessage("Error in fetching user info", "error");
            resolve({});
          }
          })
      }
    })
    return promise;
  }

  populateViewUsersModalData(response : any, modalData : any) : any {
    if (this.utilsSrv.isObjectNotNullAndEmpty(response)) {
      modalData['firstName'] = response.firstName;
      modalData['lastName'] = isNullOrUndefined(response.lastName) ? '-' : response.lastName;
      modalData['emailId'] = response.email;
      modalData['title'] = isNullOrUndefined(response.title) ? '-' : response.title;
      modalData['lastLoginTs'] = isNullOrUndefined(response.lastLoginTs) ? null : response.lastLoginTs;
      modalData['status'] = response.status ? "Active" : "Inactive";
      modalData['username'] = response.username;
      modalData['mobileNumber'] = response.mobileNo;
    }

    return modalData;
  }

  navigateToCustomApp(appDetails: any) {
    const realmDetails = JSON.parse(localStorage.getItem(USER_MGMT_CNST.REALM_DETAILS_KEY) ?? '{}');
    const customerRealmDetails: any = JSON.parse(realmDetails?.customerRealmDetailsJson ?? '{}');
    let queryParams = {
      realm: realmDetails?.realmName ?? this.envService.keyCloakOptions.realm,
      clientId: customerRealmDetails?.client_id ?? this.envService.keyCloakOptions.clientId,
    };
    const queryString = new URLSearchParams(queryParams).toString();
    window.location.href = `${appDetails?.applicationUrl}?${queryString}`;
  }

  // ===================================================================
  // BEGIN — generic table-export helper, added for Export-DWG
  //   (Railway-V-V-UI).
  //   `jspdf` / `jspdf-autotable` / `xlsx` imports at the top of this
  //   file belong to this block. ===================================================================

  /**
   * calling the below method to export data based on the selected file type
   * @param typeConfig
   */
  async export(typeConfig: any): Promise<void> {
    const { type, data, columns, fileName, orientation, options } = typeConfig;

    if(!data || !data.length) {
      this.messageService?.add({
        severity: 'info',
        summary: 'Download',
        detail: 'No data to download!'
      });
      return;
    }

    switch (type) {
      case 'pdf':
        await this.exportAsPDF(data, columns, fileName, { orientation, ...(options || {}) });
        break;
      case 'excel':
        this.exportAsExcel(data, columns, fileName);
        break;
      case 'csv':
        this.exportAsCSV(data, columns, fileName);
        break;
    }
  }


   /**
   * calling the below method to export data as pdf file
   * @param fileData
   * @param tableColumns
   * @param fileName
   * @param options
   */
   async exportAsPDF(fileData: any[], tableColumns: any, fileName: any, options?: any) {
    const columns = tableColumns?.filter((col: any) => col.field !== 'action') || [];
    const data = fileData;

    const imageCols = columns.filter((col: any) => col.type === 'image');
    const imageUrls = new Set<string>();
    if (imageCols.length > 0 && data?.length) {
      data.forEach((row: any) => {
        imageCols.forEach((col: any) => {
          const url = row[col.field];
          if (typeof url === 'string' && url.trim()) {
            imageUrls.add(url.trim());
          }
        });
      });
    }

    const imageMap = await this.preloadImages(Array.from(imageUrls));

    const orientation = options?.orientation || (columns.length > 5 ? 'landscape' : 'portrait');
    const doc = new jsPDF({ orientation, unit: 'pt', format: 'a4' });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    let currentY = 36;

    // 1. Document Title (Centered)
    const titleText = options?.title || 'QC VALIDATION REPORT';
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(15, 23, 42);
    doc.text(titleText, pageWidth / 2, currentY, { align: 'center' });
    currentY += 34;

    // 2. Station Details Section
    currentY = this.drawPDFStationDetails(doc, options?.stationInfo, currentY, pageWidth);

    // 4. Data Table
    const headers = columns.map((col: any) => col.label);
    const rows = data?.map((row: any, idx: number) =>
      columns.map((col: any) => {
        if (col.field === 's_no') return row.s_no ?? (idx + 1);
        const value = row[col.field];
        if (value === undefined || value === null || value === '') return '-';
        if (col.type === 'image') return (typeof value === 'string' && value.trim()) ? '' : '-';
        if (Array.isArray(value)) return value.join(', ');
        if (typeof value === 'object') return JSON.stringify(value);
        return String(value);
      }));

    autoTable(doc, {
      head: [headers],
      body: rows,
      startY: currentY,
      margin: { top: 30, right: 24, bottom: 30, left: 24 },
      styles: {
        fontSize: 7.5,
        cellPadding: 4,
        overflow: 'linebreak',
        valign: 'middle',
        textColor: [15, 23, 42],
        lineColor: [241, 245, 249],
        lineWidth: 0.5
      },
      headStyles: {
        fillColor: [27, 37, 55],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: 7.5,
        halign: 'left',
        valign: 'middle',
        minCellHeight: 22
      },
      alternateRowStyles: {
        fillColor: [248, 250, 252]
      },
      columnStyles: columns.reduce((styles: any, col: any, index: number) => {
        if (col.field === 's_no') styles[index] = { cellWidth: 32, halign: 'center' };
        if (col.type === 'image') styles[index] = { cellWidth: 60, halign: 'center' };
        if (col.type === 'status') styles[index] = { cellWidth: 55, halign: 'left' };
        if (col.field === 'expected_result') styles[index] = { cellWidth: 60, halign: 'left' };
        return styles;
      }, {}),
      didParseCell: (hookData: any) => {
        if (hookData.section !== 'body') {
          return;
        }
        const column = columns[hookData.column.index];
        if (column?.type === 'status') {
          hookData.cell.styles.fontStyle = 'bold';
        }
        if (column?.type === 'image' && hookData.cell.raw !== '-') {
          hookData.cell.styles.minCellHeight = 30;
        }
      },
      didDrawCell: (hookData: any) => {
        if (hookData.section !== 'body') {
          return;
        }
        const column = columns[hookData.column.index];
        const url = data?.[hookData.row.index]?.[column?.field];
        if (column?.type === 'image' && typeof url === 'string' && url.trim()) {
          const imgObj = imageMap.get(url.trim());
          if (imgObj && imgObj.dataUrl) {
            const padding = 2;
            const cellWidth = hookData.cell.width - (padding * 2);
            const cellHeight = hookData.cell.height - (padding * 2);

            let drawWidth = cellWidth;
            let drawHeight = drawWidth / imgObj.aspectRatio;

            if (drawHeight > cellHeight) {
              drawHeight = cellHeight;
              drawWidth = drawHeight * imgObj.aspectRatio;
            }
            const x = hookData.cell.x + (hookData.cell.width - drawWidth) / 2;
            const y = hookData.cell.y + (hookData.cell.height - drawHeight) / 2;
            try {
              doc.addImage(imgObj.dataUrl, imgObj.format, x, y, drawWidth, drawHeight);
            } catch (err) {
              console.error('Error adding image to PDF cell:', err);
            }

            doc.link(hookData.cell.x, hookData.cell.y, hookData.cell.width, hookData.cell.height, { url: this.resolveImageUrl(url) });
          }
        }
      }
    });

    // 5. Page Footer
    const pageCount = (doc as any).getNumberOfPages();
    const now = new Date();
    const timeStr = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true }).toLowerCase();
    const generatedOnStr = `Generated on ${now.getDate()}/${now.getMonth() + 1}/${now.getFullYear()}, ${timeStr}`;
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(7.5);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(148, 163, 184);
      doc.text(generatedOnStr, 24, pageHeight - 15);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 24, pageHeight - 15, { align: 'right' });
    }

    doc.save(`${fileName}.pdf`);
  }

  /**
   * calling the below method to export data as excel file
   * @param fileData
   * @param columns
   * @param fileName
   */
  exportAsExcel(fileData: any[], columns: any, fileName: any) {
    const data = this.getExportData(columns, fileData);
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Stations');
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  }

   /**
   * calling the below method to prepare export data based on selected headers
   * @param headers
   * @param data
   * @returns
   */
   getExportData(headers: any, data: any) {
    const columns = this.getExportColumns(headers);
    return data?.map((row: any) => {
      const newRow: any = {};
      columns.forEach((col: any) => { newRow[col.header] = row[col.field] });
      return newRow;
    });
  }

   /**
   * calling the below method to get export columns excluding action column
   * @param headers
   * @returns
   */
   getExportColumns(headers: any) {
    return headers?.filter((col: any) => col.field !== 'action').map((col: any) => ({
      field: col.field,
      header: col.label
    })) || [];
  }

  private resolveImageUrl(url: string): string {
    if (url.startsWith('http') || url.startsWith('data:')) return url;
    return window.location.origin + url;
  }

   /**
   * calling the below method to export data as csv file
   * @param fileData
   * @param columns
   * @param fileName
   */
   exportAsCSV(fileData: any[], columns: any, fileName: any) {
    const data = this.getExportData(columns, fileData);
    const headers = Object.keys(data[0]).join(',');
    const rows = data?.map((row: any) =>
      Object.values(row).map(value => {
        if (value == null) return '';
        const stringValue = value.toString();
        if (stringValue.includes(',')) {
          return `"${stringValue}"`;
        }
        return stringValue;
      }).join(',')
    );
    const csv = [headers, ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.csv`;
    link.click();
  }

  /**
   * Preload image URLs into base64 Data URLs for guaranteed embedding in PDF
   * @param urls
   * @private
   */
  private async preloadImages(urls: string[]): Promise<Map<string, { dataUrl: string; format: string; aspectRatio: number }>> {
    const map = new Map<string, { dataUrl: string; format: string; aspectRatio: number }>();
    await Promise.all(urls.map(async (url) => {
      const rawUrl = url?.trim();
      if (!rawUrl) return;
      const res = await this.fetchImageDataUrl(rawUrl);
      if (res) {
          map.set(rawUrl, res);
      }
      }));
      return map;
  }

   /**
   * Fetch image data and convert to base64 Data URL using multiple fallback methods
   * @param url
   * @private
   */
   private async fetchImageDataUrl(url: string): Promise<{ dataUrl: string; format: string; aspectRatio: number } | null> {
    if (!url || typeof url !== 'string' || !url.trim()) return null;
    const rawUrl = url.trim();
    const resolvedUrl = this.resolveImageUrl(rawUrl);

    // 1. Data URL
    if (rawUrl.startsWith('data:image/')) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          let format = 'PNG';
          if (rawUrl.startsWith('data:image/jpeg') || rawUrl.startsWith('data:image/jpg')) {
            format = 'JPEG';
          }
          const width = img.naturalWidth || img.width || 100;
          const height = img.naturalHeight || img.height || 50;
          resolve({ dataUrl: rawUrl, format, aspectRatio: width / height });
        };
        img.onerror = () => resolve(null);
        img.src = rawUrl;
      });
    }

    // 2. Inspect existing DOM <img> elements (e.g. PrimeNG <p-image>)
    try {
      const existingImg = Array.from(document.querySelectorAll('img')).find(i => i.src === rawUrl || i.src === resolvedUrl) as HTMLImageElement;
      if (existingImg && existingImg.complete && existingImg.naturalWidth > 0) {
        const canvas = document.createElement('canvas');
        const width = existingImg.naturalWidth || 100;
        const height = existingImg.naturalHeight || 50;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(existingImg, 0, 0);
          let format = 'PNG';
          if (resolvedUrl.toLowerCase().includes('.jpg') || resolvedUrl.toLowerCase().includes('.jpeg')) {
            format = 'JPEG';
          }
          const dataUrl = canvas.toDataURL(format === 'JPEG' ? 'image/jpeg' : 'image/png');
          if (dataUrl && dataUrl.startsWith('data:')) {
            return { dataUrl, format, aspectRatio: width / height };
          }
        }
      }
    } catch (e) {
      // DOM canvas export tainted, proceed to fetch
    }
    try {
      const resp = await fetch(resolvedUrl);
      if (resp.ok) {
        const blob = await resp.blob();
        const dataUrl = await new Promise<string | null>((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(blob);
        });
        if (dataUrl && dataUrl.startsWith('data:')) {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
              const width = img.naturalWidth || img.width || 100;
              const height = img.naturalHeight || img.height || 50;
              let format = 'PNG';
              if (blob.type.includes('jpeg') || blob.type.includes('jpg')) {
                format = 'JPEG';
              }
              resolve({ dataUrl, format, aspectRatio: width / height });
            };
            img.onerror = () => resolve(null);
            img.src = dataUrl;
          });
        }
      }
    } catch (e) {
      // Fetch failed, try XHR
    }

    // 4. XMLHttpRequest -> Blob -> FileReader
    try {
      const dataUrlObj = await new Promise<{ dataUrl: string; format: string; aspectRatio: number } | null>((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', resolvedUrl, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            const blob = xhr.response;
            const reader = new FileReader();
            reader.onloadend = () => {
              const resDataUrl = reader.result as string;
              if (resDataUrl && resDataUrl.startsWith('data:')) {
                const img = new Image();
                img.onload = () => {
                  const width = img.naturalWidth || img.width || 100;
                  const height = img.naturalHeight || img.height || 50;
                  let format = 'PNG';
                  if (blob.type.includes('jpeg') || blob.type.includes('jpg')) {
                    format = 'JPEG';
                  }
                  resolve({ dataUrl: resDataUrl, format, aspectRatio: width / height });
                };
                img.onerror = () => resolve(null);
                img.src = resDataUrl;
              } else {
                resolve(null);
              }
            };
            reader.onerror = () => resolve(null);
            reader.readAsDataURL(blob);
          } else {
            resolve(null);
          }
        };
        xhr.onerror = () => resolve(null);
        xhr.send();
      });

      if (dataUrlObj) return dataUrlObj;
    } catch (e) {
      // XHR failed, try Canvas
    }

    // 5. HTML Canvas toDataURL
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const width = img.naturalWidth || img.width || 100;
          const height = img.naturalHeight || img.height || 50;
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(img, 0, 0);
            let format = 'PNG';
            const lower = resolvedUrl.toLowerCase();
            if (lower.includes('.jpg') || lower.includes('.jpeg')) {
              format = 'JPEG';
            }
            const mimeType = format === 'JPEG' ? 'image/jpeg' : 'image/png';
            const dataUrl = canvas.toDataURL(mimeType);
            resolve({ dataUrl, format, aspectRatio: width / height });
            return;
          }
        } catch (e) {
          // Canvas tainted
        }
        resolve(null);
      };
      img.onerror = () => resolve(null);
      img.src = resolvedUrl;
    });
  }

  private drawPDFStationDetails(doc: jsPDF, stationInfo: any[], currentY: number, pageWidth: number): number {
    if (!stationInfo || !stationInfo.length) return currentY;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(15, 23, 42);
    doc.text('Station Details:', 24, currentY);
    currentY += 14;
    const numItems = stationInfo.length;
    const cols = 3;
    const colWidth = (pageWidth - 48) / cols;
    stationInfo.forEach((info: any, idx: number) => {
      const col = idx % cols;
      const row = Math.floor(idx / cols);
      const x = 24 + col * colWidth;
      const y = currentY + row * 16;
      doc.setFontSize(8.5);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(51, 65, 85);
      const labelText = `${info.label}: `;
      doc.text(labelText, x, y);
      const labelWidth = doc.getTextWidth(labelText);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(15, 23, 42);
      doc.text(String(info.value ?? '-'), x + labelWidth, y);
    });
    const numRows = Math.ceil(numItems / cols);
    return currentY + numRows * 16 + 10;
  }

  normalize(data: any): any {
    if (isNullOrUndefined(data)) return data;
    if (typeof data === 'string') {
      return data.trim();
    }
    if (Array.isArray(data)) {
      return data.map(item => this.normalize(item));
    }
    if (typeof data === 'object') {
      const normalized: any = {};
      Object.keys(data).forEach(key => {
        normalized[key] = this.normalize(data[key]);
      });
      return normalized;
    }
    return data;
  }
  // ===================================================================
  // END — generic table-export helper, added for Export-DWG
  // ===================================================================
}